import randomId from './randomId';
import { getCurrentEnv } from './env';

/**
 * Use regex to extract the values from the moduleId
 * @param {String} moduleId
 * @returns {Object}
 */
export function parseId(moduleId) {
  // Everything before the appearance of the > character
  const idMatch = moduleId.match(/.+?(?=>)/);

  // Everything in between but not including > and @
  const aliasMatch = moduleId.match(/\>([\w\d-]+)(@.*)?/);

  // Everything after @ and converted into an array separated by |
  const envsMatch = moduleId.match(/@(.*)$/);

  return {
    id: idMatch ? idMatch[0] : moduleId,
    alias: aliasMatch ? aliasMatch[1] : null,
    envs: envsMatch ? envsMatch[1].split('|') : []
  };
}

/**
 * If module is named then use it, else we keep track of the last required
 * module, so we use its value
 * @param {String} [moduleId]
 * @returns {String} Parsed moduleId or a random string
 */
export function parseModuleId(moduleId) {
  const id = typeof moduleId === 'string' ? parseId(moduleId).id : null;
  const parsedId = Array.isArray(id) ? id[0] : id;
  return parsedId || randomId();
}

/**
 * Return an alias if the module is defined and contains the alias symbol (>)
 * @param {String} [moduleId]
 * @returns {String} Parsed alias
 */
export function parseModuleAlias(moduleId) {
  const { alias, envs } = parseId(moduleId);

  if (envs.includes(getCurrentEnv())) {
    return alias;
  }

  return null;
}

/**
 * If the module is Anonymous then grab the dependencies from the
 * first argument, else use the second parameter or an empty array
 * @param {String|Array} moduleId
 * @param {Array|Null} dependencies
 * @return {Array} Dependencies
 */
export function parseModuleDeps(moduleId, dependencies) {
  // NOSONAR
  // It is necessary to remove this sonar rule.
  let deps = [];
  if (Array.isArray(moduleId)) {
    deps = moduleId;
  } else if (Array.isArray(dependencies)) {
    deps = dependencies;
  }
  return deps.map(_id => parseModuleAlias(_id) || parseModuleId(_id));
}